import actions from './actions';

const initState = {
    data: []
};

export default function WorkorderCommentReducer(state = initState, action) {
    switch (action.type) {
        case actions.WorkorderComment_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
